import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

const messages = defineMessages({
  loyaltyHelp: {
    id: 'loyaltyHelp',
    defaultMessage: 'Use Rewards Points?',
    description: 'Loyalty help text cta'
  },
  loyaltyPoints: {
    id: 'loyaltyDropdownPoints',
    defaultMessage: 'You have {points}pts',
    description: 'Loyalty dropdown number of points text'
  }
});

const RewardsTitleContainer = styled.div<WithStyleVariant>`
  width: 100%;
  margin: 0 0 1rem 0;

  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  color: ${({ variant }) =>
    variant === RewardsStyleVariant.Secondary ? Styles.color.white : Styles.color.secondary};
`;

const RewardPoints = styled.div`
  font-size: 1.5rem;
`;

const RewardCateogryDropdownHeader: React.FC<{ points?: number } & WithStyleVariant> = ({
  variant = RewardsStyleVariant.Primary,
  points = 0
}) => {
  const { formatMessage } = useIntl();
  return (
    <RewardsTitleContainer variant={variant} tabIndex={0}>
      <div>{formatMessage(messages.loyaltyHelp)}</div>
      <RewardPoints>{formatMessage(messages.loyaltyPoints, { points })}</RewardPoints>
    </RewardsTitleContainer>
  );
};

export default RewardCateogryDropdownHeader;
